import { Link, useSearchParams } from "react-router-dom";
import { Leaf, Lock, Sparkles, ArrowRight } from "lucide-react";

export default function FeatureGate() {
  const [searchParams] = useSearchParams();
  const feature = searchParams.get("feature") || "this feature";

  return (
    <div className="min-h-screen bg-spa-bone flex flex-col" data-testid="feature-gate-page">
      {/* Nav */}
      <nav className="flex items-center justify-between px-6 py-4 md:px-12 lg:px-20 border-b border-spa-border/30">
        <Link to="/" className="flex items-center">
          <img src="/smahoo-logo.jpg" alt="SMAHOO ME.WELL Mind-SPA exPE" className="h-14 w-auto" />
        </Link>
        <Link to="/" className="text-sm text-spa-terracotta hover:text-spa-terracotta-dark font-medium" data-testid="back-home-link">
          Back to Home
        </Link>
      </nav>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-md w-full text-center">
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-amber-100 to-amber-50 rounded-3xl flex items-center justify-center">
            <Lock className="w-10 h-10 text-amber-500" strokeWidth={1.5} />
          </div>
          <h1 className="font-serif text-3xl sm:text-4xl text-spa-moss mb-4" data-testid="gate-title">
            Sign Up to Access {feature}
          </h1>
          <p className="text-spa-text-secondary mb-8 leading-relaxed">
            You must be signed in to access <strong>{feature}</strong> and other wellness features. 
            Create a Basic profile to get started on your daily self-care journey.
          </p>
          <div className="space-y-3">
            <Link
              to="/"
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-spa-terracotta hover:bg-spa-terracotta-dark text-white rounded-2xl font-medium transition-colors"
              data-testid="gate-signup-btn"
            >
              <Sparkles className="w-4 h-4" /> Join Now — Basic Profile
            </Link>
            <Link
              to="/"
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 border border-spa-border text-spa-moss rounded-2xl font-medium hover:bg-spa-muted transition-colors"
              data-testid="gate-signin-btn"
            >
              Already have an account? Sign In <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <p className="mt-8 text-xs text-spa-text-secondary">
            Basic profiles include Dashboard, AI Coach, Mood Tracker, Streaming, and more.
          </p>
        </div>
      </div>
    </div>
  );
}
